import { useEffect, useState } from 'react';
import { type CustomDomainState } from './CustomDomainState';
import { loadCustomDomainBranding } from './loadCustomDomainBranding';

// @ai-generated 2026-10-12T14:25:59+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
export function useCustomDomainState(): CustomDomainState {
    const [state, setState] = useState<CustomDomainState>({ kind: 'loading' });

    useEffect(() => {
        let cancelled = false;
        loadCustomDomainBranding().then((loaded) => {
            if (!cancelled) {
                setState(loaded);
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return state;
}
